"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.sort");
var _ObjectForm = _interopRequireDefault(require("@/components/ObjectForm"));
var _majorType = require("@/api/project/majorType");
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    formIcon: _ObjectForm.default
  },
  data: function data() {
    return {
      formData: {
        rules: {
          majorName: [{
            required: true,
            message: "请输入专业大类名称",
            trigger: "blur"
          }],
          majorCode: [{
            required: true,
            message: "请输入专业大类编码",
            trigger: "blur"
          }],
          majorCengci: [{
            required: true,
            message: "请选择学校层次",
            trigger: "blur"
          }]
        },
        labelWidth: "120px",
        inline: false,
        labelPosition: "right",
        size: "small",
        formItem: [{
          type: "input",
          label: "专业大类名称",
          isDisabled: false,
          placeholder: "请输入专业大类名称",
          prop: "majorName",
          value: "",
          required: true,
          span: 13
        }, {
          type: "input",
          label: "专业大类编码",
          isDisabled: false,
          placeholder: "请输入专业大类编码",
          prop: "majorCode",
          value: "",
          required: true,
          span: 13
        }, {
          type: "select",
          label: "学校层次",
          isDisabled: false,
          placeholder: "请选择学校层次",
          prop: "majorCengci",
          value: "",
          span: 13,
          options: [{
            value: "1",
            label: "中职"
          }, {
            value: "2",
            label: "高职"
          }, {
            value: "3",
            label: "本科"
          }]
        }]
      }
    };
  },
  methods: {
    submit: function submit(e) {
      var _this = this;
      (0, _majorType.majorChange)({
        id: this.$route.query.id,
        majorCode: e.majorCode,
        majorName: e.majorName,
        parentId: this.$route.query.parentId,
        provinceId: this.$route.query.provinceId,
        sort: this.$route.query.sort,
        type: this.$route.query.type
      }).then(function (res) {
        _this.$router.push("/object/majorObject");
      });
    }
  },
  created: function created() {
    this.formData.formItem[0].value = this.$route.query.majorName;
    this.formData.formItem[1].value = this.$route.query.majorCode;
    // this.formData.formItem[2].value = this.$route.query.;
  }
};